export const visitIQColumns = 'visitIQ-columnsV15';
export const visitIQTaxonomyFilters = 'visitIQ-taxonomy-filtersV3';
export const visitIQGeoFilters = 'visitIQ-geo-filtersV4';
export const visitIQSettings = 'visitIQ-settings';
export const visitIQAudience = 'visitIQ-audience';
export const visitIQFilterFieldConditions = 'visitIQ-filter-field-conditionsV3';
export const visitIQGoogleAnalytics = 'visitIQ-googleAnalyticsInfo';
export const visitIQTaxonomyFiltersOperators = 'visitIQ-taxonomy-filters-operatorsV1';
export const visitIQAiPrompt = 'visitIQ-ai-prompt';
export const visitIQCategories = 'visitIQ-categories';
export const visitIQTaxonomyUserSettings = 'visitIQ-taxonomy-user-settings';
export const visitIQGlobalSearchOrg = 'visitIQ-global-search-org';
export const visitIQPulseOrg = 'visitIQ-pulse-org';
export const visitIQCurrentOrg = 'visitIQ-current-org';
export const visitIQAiInsightsSidebarWidth = 'ai-insights-sidebar-width';
export const visitIQAiSessionLimitDismissal = 'visitIQAiSessionLimitDismissal';
export const visitIQAiInsightsChatsNavWidth = 'ai-insights-chats-nav-width';
export const visitIQAiInsightsChatsNavCollapsed = 'ai-insights-chats-nav-collapsed';
// User's last-used "Automatic creation" (etc.) choice when saving a template; survives logout.
export const visitIQActivationTemplatePrefs = 'visitIQ-activationTemplatePrefs';
export const visitIQAudienceDateRange = 'visitIQ-audience-date-range';
// AI Insights auto mode toggle, suffixed with the user id so it never carries over to another user.
export const visitIQAiAutoMode = 'visitIQ-ai-auto-mode';
